import moment from "moment";

const FALLBACK_DOCUMENT_NAME = "Unnamed document";

export const getClientDocumentName = (record = {}) => {
  const safeRecord = record || {};
  const candidate = safeRecord.document || safeRecord.original_filename || safeRecord.name;
  return typeof candidate === "string" && candidate.trim() ? candidate : FALLBACK_DOCUMENT_NAME;
};

export const getClientDocumentUrl = (record = {}) => {
  const candidate = record && record.document_url;
  return typeof candidate === "string" && candidate.trim() ? candidate : "";
};

export const getClientDocumentUploadDate = (record = {}) => {
  const safeRecord = record || {};
  const value = safeRecord.uploaded_at || safeRecord.created_at;
  if (typeof value !== "string" || !value.trim()) return "";
  const date = moment(value, moment.ISO_8601, true);
  return date.isValid() ? date.format("DD/MM/YYYY, h:mm A") : "";
};

export const getClientDocumentExtension = (filename) => {
  const normalized = typeof filename === "string" ? filename.toLowerCase() : "";
  const separator = normalized.lastIndexOf(".");
  return separator >= 0 ? normalized.slice(separator + 1) : "";
};
